/**
 * Navigates to the contact page and scrolls to the calendar section
 * @param navigate - React Router navigate function
 */
export const navigateToMeeting = (navigate: (path: string, options?: any) => void) => {
    // Navigate to the contact page
    navigate('/contact', { state: { scrollToCalendar: true } });
}; 